import { useState } from "react";
import emealImage from "../assets/imgs/emeal.svg";
import linkdnImage from "../assets/imgs/linkedn.svg";
import githubIcon from "../assets/imgs/github.svg";
import emailjs from "emailjs-com";
import { toast } from "react-toastify";
import ScrollReveal from "./ScrollReveal";
import { useLanguage } from "../context/LanguageContext";
import { translations } from "../i18n";


function Contact() {
  const { language } = useLanguage();

  const [isSending, setIsSending] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    botField: "",
  });

  const validateForm = () => {
    const { name, email, message } = formData;
  
    if (!name.trim() || !email.trim() || !message.trim()) {
      toast.error(translations[language].contact.fieldsError);
      return false;
    }
  
    if (name.trim().length < 2) {
      toast.error(translations[language].contact.nameError);
      return false;
    }
  
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email.trim())) {
      toast.error(translations[language].contact.emailError);
      return false;
    }
  
    if (message.trim().length < 10) {
      toast.error(translations[language].contact.messageError);
      return false;
    }
  
    return true;
  };

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();

    if (formData.botField) {
      return;
    }

    if (!validateForm()) return;

    setIsSending(true);

    emailjs
      .send(
        "service_fdj544s",
        "template_qeyhb0g",
        {
          name: formData.name,
          email: formData.email,
          message: formData.message,
        },
        "DxhpDm_2HSolz1dgC"
      )
      .then(
        () => {
          toast.success(translations[language].contact.success);
          setFormData({ name: "", email: "", message: "", botField: "" });
          setIsSending(false);
        },
        (error) => {
          toast.error(translations[language].contact.error + error.text);
          setIsSending(false);
        }
      );
  };

  return (
    <div className="contact-container" id="contact-container">
      <div className="section-title">{">  " + translations[language].sectionTitles.contact}</div>
      <ScrollReveal delay={0.5}>
        <div className="contact-form-container">
          <div className="contact-form-links">
            <ScrollReveal delay={0.5}>
              <a
                className="contact-link"
                href="mailto:izamm1610@gmail.com"
                aria-label={translations[language].contact.email}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={emealImage} alt="Email Icon" />
                <span>{translations[language].contact.email}</span>
              </a>
            </ScrollReveal>
            <ScrollReveal delay={0.8}>
              <a
                className="contact-link"
                href="https://www.linkedin.com/in/iamizam/"
              >
                <img src={linkdnImage} alt="Linkedin Icon" />
                <span>LinkedIn</span>
              </a>
            </ScrollReveal>
            <ScrollReveal delay={1}>
              <a className="contact-link" href="https://github.com/IamIzam">
                <img src={githubIcon} alt="Github Icon" />
                <span>GitHub</span>
              </a>
            </ScrollReveal>
          </div>

          <form className="contact-form-inputs" onSubmit={handleSubmit}>
            <div className="contact-form-input">
              <input
                name="name"
                placeholder={translations[language].contact.name}
                value={formData.name}
                onChange={handleChange}
              />
              <input
                name="email"
                type="email"
                placeholder={translations[language].contact.email}
                value={formData.email}
                onChange={handleChange}
              />
              <input
                type="text"
                name="botField"
                value={formData.botField}
                onChange={handleChange}
                style={{ display: "none" }}
              />
            </div>
            <textarea
              name="message"
              className="contact-form-text"
              placeholder={translations[language].contact.message}
              value={formData.message}
              onChange={handleChange}
            />
            <button
              type="submit"
              className="contact-form-button"
              disabled={isSending}
              style={{ cursor: isSending ? "wait" : "pointer" }}
            >
              {isSending ? translations[language].contact.sending : translations[language].contact.send}
            </button>
          </form>
        </div>
      </ScrollReveal>
    </div>
  );
}

export default Contact;
